import { INetSalesValuesReport } from "../../../../api/billing/index.types";

export const INITIAL_REPORT_VALUES: INetSalesValuesReport = {
  us_stripe_total: 0,
  not_us_stripe_total: 0,
  us_stripe_total_ref_and_char: 0,
  not_us_stripe_total_ref_and_char: 0,
  us_paypal_total: 0,
  not_us_paypal_total: 0,
  paypal_total_ref_and_char: 0,
  not_us_bitpay_total_gross: 0,
  not_us_bitpay_total_net: 0,
  not_us_bitpay_total_ref_and_char: 0,
  not_us_cryptocurrency: {},
  us_cryptocurrency: {},
  us_bridger_pay_total: 0,
  not_us_us_bridger_pay_total_total: 0,
  us_letknowpay_total: 0,
  not_us_letknowpay_total: 0,
};

export enum NET_SALES_CALCULATOR_TAB_INDEXES {
  combined_sales = "combined_sales",
  us_sales = "us_sales",
  international_sales = "international_sales",
}
